import { render, staticRenderFns } from "./Roadmap.vue?vue&type=template&id=2d98d17e&"
import script from "./Roadmap.vue?vue&type=script&lang=js&"
export * from "./Roadmap.vue?vue&type=script&lang=js&"
import style0 from "./Roadmap.vue?vue&type=style&index=0&id=2d98d17e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports